import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  totalSelectedDocuments: number
  loading: boolean
  onSubmit: (notification: boolean) => void
  onClose: () => void
}

const VisibleModal = ({ totalSelectedDocuments, loading, onSubmit, onClose }: Props) => {
  return (
    <Modal
      illustration="visibility"
      title={i18n.t('documents.employee.bulk-actions.visible-dialog.title', {
        count: totalSelectedDocuments,
      })}
      description={i18n.t('documents.employee.bulk-actions.visible-dialog.description')}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={() => onSubmit && onSubmit(false)} loading={loading}>
            {i18n.t('documents.employee.bulk-actions.visible-dialog.submit_without_notify')}
          </Button>
          <Button onClick={() => onSubmit && onSubmit(true)} loading={loading}>
            {i18n.t('documents.employee.bulk-actions.visible-dialog.submit')}
          </Button>
        </>
      }
    />
  )
}

export default VisibleModal
